/* eslint-disable */
import {
  wxShare,
  isWxMiniProgram, //是否是微信小程序
  isWeixinBrowser, //是否是微信浏览器
  isAlipayMiniUa,
  isAlipayH5,
  isMoveAlpayMini,
  isJdMiniProgram,
  isBaiduBoxUa,
  isHllApp,
  isIOS,
  callApp,
  getUrlParam
} from '@/utils'
import { isXlDriverApp } from '@/utils/judgeEnv'

//app端action不统一
function getShareAction() {
  if (getUrlParam('revision')) { //司机端
    return 'shareNew'
  }
  let version = getUrlParam('version') || getUrlParam('app_ver')
  if (!isIOS()) { //安卓
    return 'share'
  } else { //ios
    if (version && version >= 5700) {
      return 'shareNew'
    }
    return 'share'
  }
}

let shareMixin = {
  methods: {
    shareAct({
      title,
      desc,
      img,
      type,
      miniprogram_path,
      miniprogram_webpage_url,
      miniprogram_id,
      link,
      success,
      error
    }, to, shareType, isShowErr) {
      if (isWeixinBrowser() || isWxMiniProgram()) {
        console.log(link, '微信分享链接')
        wxShare({
          title,
          desc,
          img,
          link,
          success,
          error
        })
      } else if (isHllApp()||isXlDriverApp()) {
        let env = ''
        try {
          env = JSON.parse(sessionStorage.getItem('vuex')).global.env
        } catch {
          env = 'driver'
        }
        let isProMini = /^[^-]+$/g.test(location.host);
        let miniprogramConf = {
          miniprogram_path: miniprogram_path || `pages/home/index?target=adv&targetUrl=${encodeURIComponent(
            link
          )}`, // 小程序路径
          miniprogram_webpage_url: miniprogram_webpage_url || link, // 小程序适配低版本的URL
          miniprogram_id: miniprogram_id || 'gh_6b18e73b21cd', // 小程序id
          miniprogram_type: isProMini ? '0' : '2' // 小程序类型：0正式版，1测试版，2体验版
        }
        console.log(shareType,getShareAction() ,'getShareAction()---->')
        let shareArg = {
          // action: getUrlParam('revision') ? 'shareNew' : (shareType || getShareAction()),
          action: shareType || getShareAction(),
          to: to || "wechat1,wechatn",
          type: type || 0, //链接
          title: title,
          content: desc,
          icon_url: img,
          ...(type == 2 ? {} : {
            link_url: link,
            ...(type == 1 && env == 'user' ? miniprogramConf : {})
          })
        }
        let json = JSON.stringify(shareArg)
        console.log(json, 'json')
        callApp(json)
      } else if (isJdMiniProgram()) {
        jd.miniProgram.postMessage({
          data: {
            shareContent: {
              title,
              imageUrl: img,
              desc,
              path: `pages/home/index?target=adv&targetUrl=${encodeURIComponent(
                link
              )}`,
              channel: 'Wxfriends,Wxmoments'
              // channel: to == 'wechatn' ? 'Wxmoments' : 'Wxfriends'
            }
          }
        })
      } else if(isAlipayMiniUa() || isAlipayH5()) {
        
        //  alipay share
        my.postMessage({
          data: {
            shareContent: {
              title: title,
              desc: desc,
              path: isMoveAlpayMini() ? `/pages/activity/webview/index?target=${encodeURIComponent(link)}` : `/pages/ad-webview/index?target=${encodeURIComponent(link)}`,
              bgImgUrl: img,
              imageUrl: img
            }
          }
        })
        
      } else if(isBaiduBoxUa()) {
        console.error(link, 'baidu share');
        
        swan.openShare({
          title: title,
          content: desc,
          appKey: 'y3dTfnWfkx2OXttMEMWlGHoB1KzMogm7',
          path:  `/pages/openShare/openShare?webViewUrl=${encodeURIComponent(link)}`,
          imageUrl: img,
          success: () => {},
          fail: () => {}
        });
      } else if(isShowErr) {
        this.$hll.toast('请在货拉拉APP或货拉拉小程序打开');
      }
    }
  },
}
export default Vue => {
  Vue.mixin(shareMixin)
}